import React, { useState } from 'react'
import i18n from '~/i18n'
import Alert from '~/Common-Objects/UI/Alert'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { CURSOR_DEEPLINK, MCP_ENDPOINT, VSCODE_DEEPLINK, getPlatformSnippet } from './platforms'
import ClientPicker from './ClientPicker'

function CopyField({ value, label, compact }) {
    const [copied, setCopied] = useState(false)

    async function copy() {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(value)
            } else {
                const el = document.createElement('textarea')
                el.value = value
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
            }
            setCopied(true)
            setTimeout(() => setCopied(false), 1800)
        } catch (err) {
            // ignore
        }
    }

    return (
        <div className={'mcp-field' + (compact ? ' mcp-field--compact' : '')}>
            {label && <label className='mcp-field__label'>{label}</label>}
            <div className='mcp-field__row'>
                <code className='mcp-field__value'>{value}</code>
                <Button
                    className='button-sml'
                    text={copied ? i18n.t('mcp:instructions.copied') : i18n.t('mcp:instructions.copy')}
                    onClick={copy}
                />
            </div>
        </div>
    )
}

function PlatformSetup({ platformId }) {
    const base = `mcp:platforms.${platformId}`
    // parseMissingKeyHandler returns the last key segment for missing keys, so check existence explicitly
    const intro = i18n.exists(`${base}.intro`) ? i18n.t(`${base}.intro`) : null
    const note = i18n.exists(`${base}.note`) ? i18n.t(`${base}.note`) : null
    const noteTitle = i18n.exists(`${base}.noteTitle`) ? i18n.t(`${base}.noteTitle`) : ''
    const steps = i18n.t(`${base}.steps`, { returnObjects: true })
    const snippet = getPlatformSnippet(platformId)
    const deeplink = platformId === 'cursor' ? CURSOR_DEEPLINK : platformId === 'vscode' ? VSCODE_DEEPLINK : null
    const deeplinkLabel = deeplink && i18n.exists(`${base}.deeplink`) ? i18n.t(`${base}.deeplink`) : null

    return (
        <div className='mcp-setup'>
            {intro && <p className='mcp-setup__intro'>{intro}</p>}

            {note && (
                <Alert type='warning' className='mar-b15' header={noteTitle} content={note} />
            )}

            {Array.isArray(steps) && steps.length > 0 && (
                <ol className='mcp-setup__steps'>
                    {steps.map((step, index) => (
                        <li key={index}>
                            <span className='mcp-setup__n'>{index + 1}</span>
                            <span>{step}</span>
                        </li>
                    ))}
                </ol>
            )}

            {deeplinkLabel && (
                <div className='mcp-setup__deeplink'>
                    <Button className='button-primary' text={deeplinkLabel} href={deeplink} />
                </div>
            )}

            {snippet && <CopyField value={snippet} label={i18n.t('mcp:instructions.configLabel')} />}
        </div>
    )
}

export default function PlatformInstructions() {
    const [active, setActive] = useState('claude')
    const clientName = i18n.t(`mcp:platforms.${active}.name`)

    return (
        <div className='mcp-body'>
            <div className='mcp-endpoint'>
                <CopyField value={MCP_ENDPOINT} label={i18n.t('mcp:instructions.endpoint')} compact />
            </div>

            <div className='mcp-setup-panel'>
                <div className='mcp-setup-panel__tabs'>
                    <ClientPicker value={active} onChange={setActive} />
                </div>
                <div className='mcp-setup-panel__body' key={active}>
                    <h2 className='mcp-setup-panel__title'>
                        {i18n.t('mcp:instructions.setupFor', { client: clientName })}
                    </h2>
                    <PlatformSetup platformId={active} />
                </div>
            </div>
        </div>
    )
}
